module.exports = __webpack_public_path__ + "img/4.1045d31e.png";